var _defs, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hot",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 80,
    viewBox: "0 0 18 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ed2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#ee3a23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f15d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#f4821f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#f58b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#f9a512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#ffcd03"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M18,71.25A8.873,8.873,0,0,1,9,80a8.88,8.88,0,0,1-9-8.75,8.652,8.652,0,0,1,4.2-7.39V4.66A4.728,4.728,0,0,1,9,0a4.73,4.73,0,0,1,4.81,4.66V63.85A8.694,8.694,0,0,1,18,71.25Z",
    fill: "#58595b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M8.81,2.43h.38a3.325,3.325,0,0,1,3.32,3.32V68.48A3.325,3.325,0,0,1,9.19,71.8H8.81a3.325,3.325,0,0,1-3.32-3.32V5.76A3.32,3.32,0,0,1,8.81,2.43Z",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 7.58,
    cy: 7.37,
    rx: 7.58,
    ry: 7.37,
    transform: "translate(1.42 63.88)",
    fill: "#ec1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureHot);
export default __webpack_public_path__ + "static/media/temperature_hot.691222333c29e056fe81221e48cd6c53.svg";
export { ForwardRef as ReactComponent };